import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function ServicesServicesPage() {
  return (
    <MainLayout>
      <SEO 
        title="Serviços - Cadastros"
        description="Gerencie cadastro de serviços"
        keywords="serviços, cadastros"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Serviços</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

